<template>
    <div id="resourceForm" class="con-exemple-prompt">
        <vs-row>
            <vs-col vs-w="12">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Libellé* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.title"
                            name="title"
                            class="w-full"
                            required
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Type* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <template v-if="type != 'show'">
                            <div
                                ref="tooltip"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Cette donnée permet de catégoriser vos grilles (Exemple : ROME, RSFP, …) . Vous pouvez sélectionner une valeur existante ou en ajouter une nouvelle."
                                style="min-height: 43px;"
                            >

                                <TypeForm
                                    v-model="resource.type"
                                    :availableTypes="types.data"
                                ></TypeForm>
                            </div>
                        </template>
                        <span v-else>{{ resource.type }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Filière* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <template v-if="type != 'show'">
                            <Multiselect
                                v-model="resource.sector"
                                name="addServiceSector"
                                :options="sectors.data"
                                track-by="id"
                                label="title"
                                :multiple="false"
                                :group-select="false"
                                placeholder="Recherche ..."
                                select-label=""
                                select-group-label=""
                                selected-label=""
                                deselect-label=""
                                deselect-group-label=""
                                :loading="sectors.loading"
                            />
                        </template>
                        <span v-else>{{ resource.sector.title }}</span>
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Description :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-textarea
                            v-if="type != 'show'"
                            v-model="resource.description"
                            name="description"
                        />
                        <span v-else>{{ resource.description }}</span>
                    </div>
                </div>

                <!-- <div class="vx-row mb-6">
                    <vs-checkbox v-model="allOccSkills" name="all" :disabled="type == 'show'">
                        Afficher tous les savoir-faire disponible
                    </vs-checkbox>
                </div> -->


                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <OccupationSkillsSelector 
                            v-model="resource.occupation_skills"
                            :displayAll="allOccSkills"
                            :gridSector="resource.sector"
                        />
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { loadSectors } from "@components/services/resources.js";
import TypeForm from "@components/form/TypeForm";
import OccupationSkillsSelector from "@components/form/OccupationSkillsSelector";

export default {
    name: 'ServiceForm',
    components: {
        TypeForm,
        Multiselect,
        OccupationSkillsSelector
    },
    props: {
        value: {
            required: false,
            type: Object
        },
        type: {
            required: true,
            type: String
        },
        isCreation: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            loadSectors,
            resource: {
                type: null,
                title: null,
                sector: null,
                description: null,
                occupation_skills: []
            },
            sectors: {
                data: [],
                loading: false
            },
            types: {
                data: [],
                loading: false
            },
            allOccSkills: false
        }
    },
    watch: {
        value (newValue, oldValue) {
            if (newValue === oldValue) return
            this.initResource()
        },
        'resource': {
            handler () {
                this.value.type              = this.resource.type;
                this.value.title             = this.resource.title;
                this.value.sector            = this.resource.sector;
                this.value.description       = this.resource.description;
                this.value.occupation_skills = this.resource.occupation_skills
                
                this.$emit('input', this.value)
            }, deep: true
        },
        hasError (value) {
            this.$emit('error', value)
        }
    },
    computed: {

        hasError() {
            let error = !this.resource.title
                || !this.resource.type
                || !this.resource.sector
                //|| !this.resource.occupation_skills.length > 0
            return error;
        },

    },
    methods: {
        fetchSectors() {
            this.sectors.loading = true;

            return loadSectors({ perpage: 9999, include:[] }).then((response) => {
                this.sectors.data = response.data.data;
                this.sectors.loading = false;
            })
        },

        fetchTypes() {
            this.types.loading = true;

            return window
                .axios({
                    method: "get",
                    url: "/api/referentiel/grids/types"
                })
                .then((response) => {
                    this.types.data = response.data;
                    this.types.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },

        initResource() {
            
            let occSkills = [...this.value.occupation_skills, ...this.value.admin_occupation_skills];
            occSkills = occSkills.sort((a, b) => a.pivot.order - b.pivot.order)

            this.resource = {
                type: this.value.type,
                title: this.value.title,
                sector: this.value.sector,
                description: this.value.description,
                occupation_skills: occSkills
            }
        },

    },
    async created() {
        this.initResource();

        this.$vs.loading();
        await Promise.all([
            this.fetchTypes(),
            this.fetchSectors()
        ]);
        this.$vs.loading.close();
    }
}
</script>

<style lang="scss" scoped>
#resourceForm {
    display: block;
    > div {
        padding: 1rem;
    }

    // ::v-deep input {
    //     min-height: 43px;
    //     padding: 1rem 1.3rem;
    //     font-size:1.1rem;
    // }
    .multiselect {
        min-height: 43px;
        &.multiselect--disabled {
            border-radius: 5px;
            ::v-deep .multiselect__select {
                border-radius: 0 4px 4px 0;
                height: 41px;
            }
        }
    }
}
</style>
